import CalculatedResultsItemValue from '@modules/calculator/components/CalculatedResultsItemValue';
const CalculatedResultsItem = ({ item, isLoading }) => {
    return (<div className="flex justify-between items-start">
            <div className="body-s">
                <p>{item.label}</p>
                {item.additionalInfo && <p>{item.additionalInfo}</p>}
            </div>
            <p className="title-s">
                <CalculatedResultsItemValue isLoading={isLoading} item={item}/>
            </p>
        </div>);
};
export default CalculatedResultsItem;
